const getBranding = async () => {
  const { default: brand } = await import("@/api/brand.api");
  return (await brand.getBranding()).data;
};

const getStylesheet = async () => {
  const { default: brand } = await import("@/api/brand.api");
  const response = await brand.getBrandingCss({ responseType: "text" });
  const { data } = response;

  if (typeof data === "string") {
    return data;
  }

  return data.text();
};

export const requests = {
  key: "branding",
  getBranding,
  getStylesheet,
};
